module.exports = __webpack_public_path__ + "static/Camouflage-b3c2405c06b3b59d7f113800a556aed7.png";